import draftToHtml from "draftjs-to-html";

export default function HTML_Renderer({ content, style, className }) {
  if (!content) return <></>;

  const html = draftToHtml(JSON.parse(content));
  return (
    <div
      className={"html-renderer " + (className || "")}
      style={style}
      dangerouslySetInnerHTML={{
        __html: html.replace("font-family: Open Sans", ""),
      }}
    />
  );
}
